import { render, staticRenderFns } from "./ListSelectedVisitPoints.vue?vue&type=template&id=2c94962d&scoped=true"
import script from "./ListSelectedVisitPoints.vue?vue&type=script&lang=js"
export * from "./ListSelectedVisitPoints.vue?vue&type=script&lang=js"
import style0 from "./ListSelectedVisitPoints.vue?vue&type=style&index=0&id=2c94962d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94962d",
  null
  
)

export default component.exports